Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.PostDateFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/date/old_date_filter"]
  className: 'filter time collapsed'

  events:
    'click #apply-date': '_addDate'
    'change #now': '_onNowChange'
    'click #from': 'selectingFrom'
    'click #to': 'selectingTo'
    'click #from_time': 'validateTime'
    'click #to_time': 'validateTime'

  fields:
    date_from_realtime: 'date_from_realtime'
    date_from: 'date_from'
    date_from_ISO: 'date_from_ISO'
    date_to: 'date_to'
    date_to_ISO: 'date_to_ISO'
    date_now: 'date_now'

  initialize: ({searchQuery, facet, filtersContainer}) ->
    @searchQuery = searchQuery
    @facet = facet
    @title = I18n.t('monitoring.dashboard.filters.filter_names.time.name')
    @filtersContainer = filtersContainer


  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(currentDate: @currentDate(), viewId: @cid, title: @title))
    @_renderDatePicker()
    @$el.find('.radio, .real-time').hide()

    @$el.find('.timerange').get(0).checked = true
    @$el.find('.realtime').get(0).checked = false
    if @searchQuery.get('post_from')
        @$el.find('.datepicker.from').datepicker().data('datepicker').setDate(new Date(@searchQuery.get('post_from')))
    else
        @$el.find('.datepicker.from').datepicker().data('datepicker').setDate(new Date())
    @$el.find("#from_time option[value=\"#{new Date(@searchQuery.get('post_from')).toTimeString().substring(0,5)}\"]").prop('selected', true)
    if @searchQuery.get('post_to')
        @$el.find('.datepicker.to').datepicker().data('datepicker').setDate(new Date(@searchQuery.get('post_to')))
        @$el.find("#to_time option[value=\"#{new Date(@searchQuery.get('post_to')).toTimeString().substring(0,5)}\"]").prop('selected', true)
    if @searchQuery.get('post_now')
      @$el.find('#now').get(0).checked = true
      @_onNowChange()

    @_handleRadioButtons()
    return this

  _renderDatePicker: () ->
    @$el.find('.datepicker').datepicker({
      container: @filtersContainer,
      todayBtn: 'linked',
      autoclose: true
    })
    @$el.find('.datepicker.from').datepicker('update', new Date().format('DD-MM-YYYY'))
    @$el.find('.datepicker.to').datepicker('update',  new Date().format('DD-MM-YYYY'))
    datePickerFrom = @$el.find('.datepicker.from').datepicker().data('datepicker')
    datePickerTo = @$el.find('.datepicker.to').datepicker().data('datepicker')

    @$el.find('.datepicker.from').on('changeDate', (ev) =>
      newDate = new Date(ev.date)
      if newDate && (datePickerTo.getDate() < newDate)
        @$el.find('.datepicker.to').datepicker('update', newDate)
        @validateTime()
    )
    @$el.find('.datepicker.to').on('changeDate', (ev) =>
      newDate = new Date(ev.date)
      if datePickerFrom.getDate() > newDate
        @$el.find('.datepicker.from').datepicker('update', newDate)
        @validateTime()
    )

  _handleRadioButtons: =>
    specificTimeDiv = @$el.find('.specific-time')
    realtimeDiv = @$el.find('.real-time')
    if @$el.find('.realtime').get(0).checked == true
      realtimeDiv.find('#realtime_cbo').removeAttr('disabled')
      specificTimeDiv.find('input,select').each(
        (index, element) =>
          if (element.type != "radio")
            $(element).attr('disabled', true)
      )
      specificTimeDiv.find('.calendar').off('click')
    else
      realtimeDiv.find('#realtime_cbo').attr('disabled', true)
      @$el.find('#from').removeAttr('disabled')
      @$el.find('#from_time').removeAttr('disabled')
      @$el.find('#now').removeAttr('disabled')
      unless @$el.find('#now').get(0).checked
        @$el.find('#to').removeAttr('disabled')
        @$el.find('#to_time').removeAttr('disabled')
      @$el.find('.calendar').on('click', @_onClickCalendar)

  prefix: ->
    'date'

  _addDate: =>
    @searchQuery.removePostDateTo()
    @searchQuery.removePostDateFrom()
    @searchQuery.setPostNowDate(false)

    dateFrom = @$el.find('#from').val() + ' ' + @$el.find('#from_time').val()
    dateTo = @$el.find('#to').val() + ' ' + @$el.find('#to_time').val()
    now = @$el.find('#now').get(0).checked
    if @$el.find('#to').val() == ""
        now = true
    @searchQuery.addPostDateTo(new Date(dateTo)) unless now
    @searchQuery.addPostDateFrom(dateFrom);
    @searchQuery.setPostNowDate(now);
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _onNowChange: =>
    now = @$el.find('#now').get(0).checked
    @$el.find('#to').attr('disabled', now)
    @$el.find('#to_time').attr('disabled', now)

  selectingFrom: =>
    @$el.find('.to').datepicker("hide")

  selectingTo: =>
    @$el.find('.from').datepicker("hide")

  currentDate: =>
    date = Date()
    currentDate = date.substr(8,2) + ' ' + date.substr(4,3) + ' ' + date.substr(13,2)

  validateTime: =>
    fromTime = @$el.find('#from_time').val()
    toTime = @$el.find('#to_time').val()
    if (@$el.find('#from').val() == @$el.find('#to').val()) && (fromTime > toTime)
      @$el.find('#to_time').val(fromTime)

  isEmpty: ->
    false
